import { useAuth } from "hooks/useAuth";
import { useRoutes } from "react-router";
import { getRoutes } from "routes";

const App = () => {
  const { role } = useAuth();
  return useRoutes(getRoutes(role));
};

export default App;
